module.exports = __webpack_public_path__ + "static/sporting_fc_logo-b325f86bb07746529c4a0cfd3a1aa13d.png";